export const titleDocument = ({ title }: any) => title[0].props.children;
